<template>
  <!--  社区分享-->
  <div class="communityShare" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="comments_info">
      <div class="info_top">
        <img class="info_pic" :src="communityInfo.headimg" alt="" />
        <div class="info_name">
          <span style="font-size: medium;font-weight: 400;">{{
            communityInfo.name
          }}</span>
          <span style="font-size: small;color: #9B9B9B;">{{
            communityInfo.hospitalName
          }}</span>
        </div>
      </div>
      <div class="info_content">
        <communityText :info="communityInfo.content" />
        <span>发布于：{{ communityInfo.createdTime }}</span>
      </div>
    </div>
    <van-divider
      :style="{ 'border-bottom': '5px solid #EEEFF1', margin: '0' }"
    />
    <!-- 图片类型 -->
    <div class="contentInfo" v-if="communityInfo.type === 'IMAGE'">
      <div style="text-align: center;font-weight: bold;margin-bottom: 10px;">
        {{ communityInfo.contentObj.title }}
      </div>
      <!-- 图片 -->
      <div v-for="item in communityInfo.contentObj.images" :key="item">
        <img style="width: 100%;height: 100%;border-radius: 8px" :src="item" alt="" />
      </div>
    </div>
    <!-- 视频类型 -->
    <div class="contentInfo" v-if="communityInfo.type === 'VIDEO'">
      <div style="text-align: center;font-weight: bold;margin-bottom: 10px;">
        {{ communityInfo.contentObj.title }}
      </div>
      <video :src="communityInfo.contentObj.url" controls style="width: 100%;"></video>
    </div>

    <!-- <div class="community_list">
      <h4>评论</h4>
      <van-divider :style="{ margin: '10px' }" />
      <div v-for="list in communityInfo.comments" :key="list.id">
        <div class="list_top">
          <img :src="list.headimg" alt="" />
          <div class="list_name">
            <span style="font-size: small">{{ list.name }}</span>
            <div class="list_time">
              <span>{{ list.hospital_name }}</span>
              <span>{{ list.created_time }}</span>
            </div>
          </div>
        </div>
        <div style="padding-left:45px;margin: 10px auto">
          <communityText :info="list.content" />
        </div>
        <div
          v-for="item in list.commentTwos"
          :key="item.id"
          style="padding-left:50px;margin: 10px auto"
        >
          <div v-if="item">
            <div class="list_top" style="margin: 10px auto">
              <img :src="item.headimg" alt="" />
              <div class="list_name">
                <span style="font-size: small">{{ item.name }}</span>
                <div class="list_time">
                  <span>{{ item.hospital_name }}</span>
                  <span>{{ item.created_time }}</span>
                </div>
              </div>
            </div>
            <div style="padding-left:45px;margin: 10px auto">
              <communityText :info="list.content" />
            </div>
          </div>
        </div>
      </div>

      <div style="width: 100%;height: 130px;margin: 40px auto 0;">
        <img
          style="width: 100%;height: 100%;border-radius: 8px"
          :src="communityInfo.cover"
          alt=""
        />
      </div>
    </div> -->
    <van-divider :style="{ 'border-bottom': '5px solid #EEEFF1' }" />
<!--    <div class="community_list">-->
<!--      <h3 style="margin: 0">热门推荐</h3>-->
<!--      <videoView :videoList="communityInfo.recomMends" />-->
<!--    </div>-->
<!--    路由上带formRouter = App的则不显示这个代开云ICU-->
    <openAPP v-if="$route.query.formRouter !== 'App'"/>
  </div>
</template>

<script>
import { getCommunityInfo } from "@/service/subscribeShare_api";
import { Notify } from "vant";

export default {
  name: "communityShare",
  data() {
    return {
      showMore: false,
      fullscreenLoading: false,
      hasMoreArrow: 0,
      communityInfo: {
        contentObj: {
          title: "",
          images: [],
        },
      },
    };
  },
  components: {
    openAPP: () => import("../../components/share_foot"),
    communityText: () => import("../../components/community_text"),
    // eslint-disable-next-line vue/no-unused-components
    videoView: () => import("../../components/videoRecommended"),
  },
  mounted() {
    this.getCommunity(this.$route.query.id);
  },
  methods: {
    async getCommunity(id) {
      this.fullscreenLoading = true;
      const info = await getCommunityInfo(id);
      if (info.code === 0) {
        this.communityInfo = info.data;
        console.log("数据", this.communityInfo);
      } else {
        Notify({ type: "danger", message: "连接失败" + info.message });
      }
      this.fullscreenLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .contentInfo{
    padding: 15px;
  }
.communityShare {
  .comments_info {
    padding: 15px;
    .info_top {
      display: flex;
      align-items: center;
      .info_pic {
        width: 40px;
        height: 40px;
        border-radius: 40px;
        background-color: white;
        margin-right: 10px;
      }

      .info_name {
        display: grid;
      }
    }
    .info_content {
      padding: 5px;
      span {
        font-size: small;
        color: #aaaaaa;
      }
    }
  }
  .community_list {
    margin: 0 auto;
    padding: 15px;
    h4 {
      margin: 0;
    }
    .list_top {
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        background-color: white;
        margin-right: 10px;
      }
      .list_name {
        width: 100%;
        .list_time {
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: small;
            color: #9b9b9b;
          }
        }
      }
    }
  }
}
</style>
